import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate('/login');
  }

  return (
    <div style={styles.layout}>
      <header style={styles.header}>
        <div style={styles.brand}>
          <span>🎁</span>
          <span style={styles.brandName}>Reyes Magos</span>
          <span className="badge badge-admin">Admin</span>
        </div>
        <div style={styles.headerRight}>
          <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>{user?.display_name}</span>
          <button className="btn btn-ghost" style={{ padding: '0.4rem 0.8rem', fontSize: '0.8rem' }} onClick={() => navigate('/home')}>
            👤 Mi vista
          </button>
          <button className="btn btn-ghost" style={{ padding: '0.4rem 0.8rem', fontSize: '0.8rem' }} onClick={handleLogout}>
            Salir
          </button>
        </div>
      </header>

      <nav style={styles.nav}>
        <NavLink to="/admin/usuarios" style={navStyle} className={({ isActive }) => isActive ? 'nav-active' : ''}>
          👥 Usuarios
        </NavLink>
        <NavLink to="/admin/sorteo" style={navStyle}>
          🎰 Sorteo
        </NavLink>
      </nav>

      <main style={styles.main}>
        <Outlet />
      </main>

      <style>{`
        .nav-active { color: var(--gold) !important; border-bottom: 2px solid var(--gold); }
      `}</style>
    </div>
  );
}

const navStyle = ({ isActive }) => ({
  color: isActive ? 'var(--gold)' : 'var(--text-muted)',
  textDecoration: 'none',
  padding: '0.6rem 1rem',
  fontSize: '0.9rem',
  borderBottom: isActive ? '2px solid var(--gold)' : '2px solid transparent',
  transition: 'all 0.2s',
});

const styles = {
  layout: { minHeight: '100vh', display: 'flex', flexDirection: 'column' },
  header: {
    background: 'var(--bg-card)',
    borderBottom: '1px solid var(--border)',
    padding: '0.75rem 1rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  brand: { display: 'flex', alignItems: 'center', gap: '0.5rem', fontFamily: 'var(--font-display)' },
  brandName: { fontSize: '1.1rem', color: 'var(--gold)', fontWeight: 700 },
  headerRight: { display: 'flex', alignItems: 'center', gap: '1rem' },
  nav: {
    background: 'var(--bg-card)',
    borderBottom: '1px solid var(--border)',
    padding: '0 0.5rem',
    display: 'flex',
    gap: '0.25rem',
    overflowX: 'auto',
  },
  main: { flex: 1, maxWidth: '700px', margin: '0 auto', width: '100%', padding: '0.5rem' },
};
